/*
 * @Author: edvardchen
 * @Date:   2016-11-17 15:33:16
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-11-17 17:58:06
 */

/**
 * 通过加载图片的方式获取图片尺寸
 * @param  {String} src
 * @return {Promise}
 */
export default function getImageDimension(src) {
  return new Promise((resolve, reject) => {
    const image = new global.Image();
    image.onload = () =>
      resolve({
        width: image.naturalWidth,
        height: image.naturalHeight,
      });
    image.onerror = reject;
    image.src = src; // start loading
  });
}
